/* istanbul ignore file */
import React from 'react';
import { ListHeader } from 'framework/list';

const SendEmailHeader = ({ taskName = '...' }: { taskName?: string }) => (
  <ListHeader label={`You are here to complete task ${taskName}`} icon="icon-envelope icons font-2xl" />
);

export default SendEmailHeader;
